@if (menuItems && menuItems.length > 0 && isContextMenuVisible) {
  <div class="context-menu">
    @for (item of menuItems; track item) {
      <dx-context-menu-item [ngClass]="{ 'divider-item': item.divider }">
        <button [class.divider]="item.divider" [disabled]="item.disabled" (click)="emitEvent(item.label)">
          @if (!!item.imageSrc) {
            <img class="button-image" [src]="item.imageSrc" alt="logo" />
          }
          {{ item.label }}
        </button>
      </dx-context-menu-item>
    }
  </div>
}
